import { render, staticRenderFns } from "./CartSummaryPdaDesktop.vue?vue&type=template&id=12f26bc0&scoped=true&"
import script from "./CartSummaryPdaDesktop.vue?vue&type=script&lang=js&"
export * from "./CartSummaryPdaDesktop.vue?vue&type=script&lang=js&"
import style0 from "./CartSummaryPdaDesktop.vue?vue&type=style&index=0&id=12f26bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f26bc0",
  null
  
)

export default component.exports